import styled from 'styled-components';
import CenteredRowDiv from '../shared/CenteredRowDiv';

export const GenericGreetingContainerDiv = styled.div`
  padding: ${(p) => p.theme.unit(6)} 0;

  @media screen and (max-width: ${(p) => p.theme.breakpoint.tablet}px) {
    padding: ${(p) => p.theme.unit(3)} 0;
  }
`;

export const GreetingSectionHeaderDiv = styled.div`
  ${({ theme }) => theme.typographyRebrand.heading['3xl']}

  text-align: ${(p) => p.textAlign || 'center'};
  color: ${(p) => p.theme.c.text.primary};
`;

export const GreetingSectionSubHeaderDiv = styled.div`
  margin-top: ${(p) => p.theme.unit(2)};

  ${({ theme }) => theme.typographyRebrand.body.lg}
  color: ${(p) => p.theme.c.primary};

  text-align: ${(p) => p.textAlign || 'center'};
`;

export const GreetingCenteredSectionWithTopMargin = styled(CenteredRowDiv)`
  margin-top: ${(p) => (p.top
    ? `${p.top}px`
    : p.theme.unit(2))};
`;

export const GreetingSectionImage = styled.img`
  height: ${(p) => p.size}px;
  width: ${(p) => p.size}px;

  max-height: 100%;
  max-width: 100%;
  object-fit: contain;
`;
